<template>
    <div class="connection" @click="hideNotificationHandler" :style="status ? 'display: block' : 'display: none'">
        <div class="notification-content">
           <div class="notification-content--icon" :class="type === 0 ? 'notification-content--icon-animation' : ''">
               <slot></slot>
           </div>
           <div class="notification-content--text">{{text}}</div>
            <div v-if="type === notificationType.link" class="notification-content--close">
                <svg width="58" height="20" viewBox="0 0 58 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M54 6L46 14" stroke="#999999" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M46 6L54 14" stroke="#999999" stroke-width="1.04" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        </div>
        <div class="notification-footer" v-if="type === notificationType.link" @click="goToUrl">
            <span>Перейти к задаче</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-top: 3px">
                <path d="M4.5 9.75L8.25 6L4.5 2.25" stroke="#3D7AA5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {notificationStatus} from "@/core/const";


export default defineComponent({
    name: "VNotification",
    props: {
        status: {
            type: Boolean,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        type: {
            type: Number,
            required: true
        },
        link: {
            type: Number
        }
    },
    emits: ['hideNotification'],
    data() {
        return {
            notificationType: notificationStatus
        }
    },
    methods: {
        goToUrl() {
            this.$router.push({name: 'Task', params: {id: String(this.link)}})
            this.hideNotificationHandler()
        },
        hideNotificationHandler() {
            this.$emit('hideNotification')
        }
    }
})
</script>

<style scoped>
.connection {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);

    display: flex;
    justify-content: center;
    flex-direction: column;

    z-index: 2001;

    transition: .2s;

    border-radius: 8px;
    background: #FFF;
    box-shadow: 0 15px 71px 0 rgba(0, 0, 0, 0.14);

    padding: 10px 16px;
}

.dark .connection {
    background: var(--dark-bg-700);
    color: var(--text-color)
}

.notification-content {
    display: flex;
    align-items: center;
    justify-content: center;
}

.notification-content--text {
    padding-left: 8px;

    white-space: nowrap;

    color: var(--text-color);
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
}

.notification-content--icon {
    display: flex;
    align-items: center;
}

.notification-content--icon-animation {
    animation:spin 4s linear infinite;
}

.notification-content--close {
    display: flex;
    align-items: center;

    cursor: pointer;
}

.notification-footer {
    margin-top: 8px;

    cursor: pointer;

    color: var(--primary);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
	display: flex;
	align-items: center;
}

@keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
        transform:rotate(360deg);
    }
}
</style>
